import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';
import agreementStyles from '../ClientAgreement.module.css';

const AgreementPage12 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="none" currentPage={12} noScroll>
    <div className={agreementStyles.contentHeader}>
      Exhibit 6<br />
      Notice of Cancellation Rights
      <br />
      <br />
    </div>
    <b>Date:</b> {new Date().toDateString()}
    <br />
    <br />
    You may cancel this agreement with Ascend Debt Relief PLLC at any time without any penalty. To cancel your agreement, send an email to:
    <br />
    <br />
    <b>
      <a target="_blank" href="mailto:ds@ascenddebtrelief.com">
        ds@ascenddebtrelief.com
      </a>
    </b>
    <br />
    <br />
    In the email, please explain the date that you would like to cancel. We would also appreciate
    the reason for cancellation to review and make necessary changes in the future.
    <br />
    <br />
    Please allow 5 business days for the cancellation to be in effect.
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage12 as any);

export default connect(state => ({
  name: formSelector(state, 'name')
}))(form) as any;
